'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _a;
var DEFAULT_NAVIGATION_TYPE = exports.DEFAULT_NAVIGATION_TYPE = 'homepage';
var DEFAULT_NAV_BUTTON = exports.DEFAULT_NAV_BUTTON = 'default';
var PLATFORM_NAV_BUTTON_LIGHT = exports.PLATFORM_NAV_BUTTON_LIGHT = 'platformLight';
var PLATFORM_NAV_BUTTON_DARK = exports.PLATFORM_NAV_BUTTON_DARK = 'platformDark';
var TRANSPARENT_NAV_BAR = exports.TRANSPARENT_NAV_BAR = 'transparent';
var PLATFORM_NAV_BAR = exports.PLATFORM_NAV_BAR = 'platform';
var theme = exports.theme = {
    sizes: {
        font: '14px'
    },
    colors: {
        homepage: {
            background: '#fff',
            font: '#212124',
            dropdown: '#414345'
        },
        platform: {
            background: 'linear-gradient(90deg, #232526 0%, #414345 100%)',
            font: '#fff',
            dropdown: '#414345'
        },
        transparent: {
            background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.4) 30%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0) 90%)',
            font: '#fff',
            dropdown: '#414345'
        }
    },
    height: {
        homepage: {
            height: '64px'
        },
        platform: {
            height: '52px'
        },
        transparent: {
            height: '64px'
        }
    },
    spacings: {
        homepage: {
            padding: '0',
            menuPadding: '0 0.75rem'
        },
        platform: {
            padding: 0,
            menuPadding: '0 0.75rem'
        },
        transparent: {
            padding: '0',
            menuPadding: '0 0.75rem'
        }
    },
    padding: '0 1rem',
    logos: {
        homepage: 'v1/-logos-2019/logo-90-black.svg',
        platform: 'v1/-logos-2019/logo-90-white.svg',
        transparent: 'v1/-logos-2019/logo-90-white.svg'
    },
    logosNew: {
        homepage: '-design-system/-logo-2023/PNG/iconmark/default.png',
        platform: '-design-system/-logo-2023/iconmark/white.svg',
        transparent: '-design-system/-logo-2023/iconmark/white.svg'
    },
    boxShadows: {
        homepage: '1px 1px 12px rgba(0, 0, 0, 0.08)',
        platform: '1px 1px 12px rgba(0, 0, 0, 0.08)',
        transparent: 'none'
    },
    mobileBoxShadows: {
        homepage: '0px 2px 48px rgba(0, 0, 0, 0.1)',
        platform: '1px 1px 12px rgba(0, 0, 0, 0.08)',
        transparent: 'none'
    },
    headerBackgrounds: {
        homepage: '#fff',
        platform: '#070707',
        transparent: 'linear-gradient(180deg, rgba(0, 0, 0, 0.4) 30%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0) 90%)'
    },
    mobileHeaderBackgrounds: {
        homepage: 'rgba(255, 255, 255, 0.8)',
        platform: '#070707',
        transparent: 'rgba(255, 255, 255, 0.8)'
    },
    separators: {
        homepage: false,
        platform: false,
        transparent: false
    },
    notifications: {
        homepage: false,
        platform: true,
        transparent: false
    },
    buttons: (_a = {}, _a[DEFAULT_NAV_BUTTON] = {
        type: 'button-small',
        color: 'action-1'
    }, _a[PLATFORM_NAV_BUTTON_LIGHT] = {
        type: 'button-secondary-full',
        color: 'rgba(237, 237, 237, 0.15)'
    }, _a[PLATFORM_NAV_BUTTON_DARK] = {
        type: 'button-secondary-full',
        color: 'rgba(32, 32, 32, 0.3)'
    }, _a),
    mobileMenuItemsPosition: {
        homepage: {
            top: '16px',
            right: '18px'
        },
        platform: {
            top: '10px',
            right: '20px'
        },
        transparent: {
            top: '16px',
            right: '18px'
        }
    }
};
//# sourceMappingURL=navigation-bar-styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/config/data/navigation-bar-styles.js
// module id = 521
// module chunks = 0